/**
 * Overworld
 *
 * @type {Object}
 */
Game.States.World = {

	debug_tile: {},

	debug_player: {},

	player: null,

	map: null,

	params: null,


	/**
	 * Initialize the state.
	 *
	 * @param  {Object} params A json object storing the level parameters.
	 * @return {[type]}        [description]
	 */
	init: function( params ) {

		if ( params ) {

			this.params = params;

		}

	},


	/**
	 * Create game world
	 */
	create: function() {

		// game.renderer.renderSession.roundPixels = true; // Round pixels for the renderer
		// Phaser.Canvas.setImageRenderingCrisp( game.canvas ); // Set image rendering to be crisp (no antialiasing)
		// Phaser.Canvas.setSmoothingEnabled( game.context, false ); // Set the context to not smooth images
		// Phaser.Stage.scaleMode = Phaser.StageScaleMode.SHOW_ALL; // Ensure the scale mode shows all content

		// Stop all sounds
		game.sound.stopAll();

		// Create drawing layers.
		this.layers = Game.Utils.Layers.init();

		Game.Utils.Signposts.init( this.layers );

		Game.Utils.Hud.init( this.layers );

		// Create player
		this.player = new Game.Prefabs.Player( game, 0, 0, this.layers.groupElements );

		// Background sound effect.
		Game.Utils.Audio.play_loop( 'wind' );

		// load level
		if ( 'room' === this.params.type ) {
			Game.Utils.Map.load_room( this.params.slug, this.layers, this.params );
		} else {
			Game.Utils.Map.load_world( this.params.slug, this.layers, this.params );
		}

		Game.Utils.ManageWorld.init( this.layers );

		this.player.x = Game.Utils.Map.player_position.x;
		this.player.y = Game.Utils.Map.player_position.y;
		this.player.bringToTop();

		if ( Game.debug ) {

			this.debug_tile = new Phaser.Rectangle( 0, 0, Game.Utils.Map.TILE_SIZE, Game.Utils.Map.TILE_SIZE );
			this.debug_player = new Phaser.Rectangle( 0, 0, 2, 2 );

		}

		// Setup the game camera.
		Game.Utils.Camera.set_target( this.player );

		game.camera.roundPx = true;

		this.start_game();

	},


	/**
	 * Update game
	 */
	update: function() {

		if ( 'play' === Game.game_state ) {

		}

		// Update game properties.
		Game.Utils.ManageWorld.update( this.player );

	},


	/**
	 * Start the race and set all relevant variables.
	 */
	start_game: function() {

		// Game.Utils.Audio.play_loop( 'theme' );

		game.camera.focusOn( this.player );

		game.camera.flash( Game.background_color, 700 );

	},


	/**
	 * Apply render time effects.
	 */
	render: function() {

		// Do all the debug things.
		if ( Game.debug ) {

			this.debug_player.x = this.player.x - 1;
			this.debug_player.y = this.player.y - 1;

			// console.log( 'player', this.player.x, this.player.y );

			Game.Utils.Map.debug_zones();

			game.debug.body( this.player );

			var zone = game.camera.deadzone;
			game.context.fillStyle = 'rgba(255,0,0,0.6)';
			game.context.fillRect( zone.x, zone.y, zone.width, zone.height );

		}

	},

	preRender: function() {

		Game.Utils.ManageWorld.pre_render( this.player );

	},

};
